import React from 'react';
import { useTheme } from '../../../utils/context/theme-context';
import {
    WagtailModulePagesBreadCrumb,
    WagtailModulePagesBreadCrumbItem,
} from '../../../utils/WagtailModulePagesBreadCrumb';
import CTABlock from '../../sharedComponents/cta-block/CTABlock';
import {
    CTA_BLOCK_BUTTON_VARIANT,
    CTA_BLOCK_LARGE_SIZE,
} from '../../sharedComponents/cta-block/utils';
import { BaseModuleProps, ICTABlock, IImageBlock } from '../types';
import './HeroCallToAction.scss';

interface IHeroCallToAction {
    headline: string;
    subText?: string;
    cta: ICTABlock;
    image: IImageBlock;
    breadcrumbs?: WagtailModulePagesBreadCrumbItem[];
}

export type HeroCallToActionProps = IHeroCallToAction & BaseModuleProps;

const HeroCallToAction = ({
    headline,
    subText,
    cta,
    image,
    variant,
    breadcrumbs,
}: HeroCallToActionProps) => {
    const baseOptions = { variant };
    const theme = useTheme();
    const [backgroundClass] = theme.generateStyles('background', baseOptions);
    const [overlayClass] = theme.generateStyles(
        'overlay-gradient',
        baseOptions,
    );
    const [titleClass] = theme.generateStyles('text', baseOptions);
    const [subtitleClass] = theme.generateStyles('text', baseOptions);

    return (
        <section className={`hero-cta ${backgroundClass}`}>
            <div className={`hero-cta__image-container ${overlayClass}`}>
                <img src={image.imageUrl} alt="" />
            </div>
            <div className="module-landing-page__module-container-content">
                {breadcrumbs ? (
                    <WagtailModulePagesBreadCrumb
                        breadcrumbs={breadcrumbs}
                        containerClasses={`hero-cta__breadcrumbs ${subtitleClass}`}
                        navClasses="breadcrumbs--no-margin"
                    />
                ) : null}
                <h1 className={titleClass}>{headline}</h1>
                {subText && (
                    <span data-testid="subtext" className={subtitleClass}>
                        {subText}
                    </span>
                )}
                <CTABlock
                    callToAction={cta.callToAction}
                    url={cta.url}
                    variant={CTA_BLOCK_BUTTON_VARIANT}
                    size={CTA_BLOCK_LARGE_SIZE}
                    themeVariant={variant}
                />
            </div>
        </section>
    );
};
export default HeroCallToAction;
